import AppHeader from '../AppHeader'
import AppFooter from '../AppFooter'
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'home',
  created () {
    this.initialization()
    this.magazineGet()
    this.stepupGet()
    this.evaluateAnswerGet()
    this.serviceAnswerGet()
    this.getEsMycard()
    this.checkMovieExistence()

    if (localStorage.is_shop_master == 1 || localStorage.is_clerk == 1) {
      this.stepupCallGet()
      this.evaluateAnswerCallGet()
      this.serviceAnswerCallGet()
    }
  },
  data () {
    return {
      infoOpen: true,
      menuOpen: true,
      magazineCallbackFlag: false,
      watchStepUps: '',
      nowStepUps: '',
      onceEndStepUps: '',
      isStepUpExist: false,
      isStepUpCallExist: false,
      stepUpGetEnd: false,
      isEvaluateAnswerExist: false,
      isEvaluateAnswerCallExist: false,
      isServiceAnswerExist: false,
      serviceAnswerIsOwn: [],
      isServiceAnswerCallExist: false,
      serviceQuestions: [],
      watchEvaluateAnswers: [],
      nowEvaluateAnswers: [],
      onceEndEvaluateAnswers: [],
      watchServiceAnswers: [],
      nowServiceAnswers: [],
      onceEndServiceAnswers: [],
      evaluateAnswerGetEnd: false,
      serviceAnswerGetEnd: false,
      userTypesQuestion: false,
      editStepUpId: '',
      editEvaluateAnswerId: '',
      editServiceAnswerId: '',
      card: {
        id: null,
        is_already_read: false,
        give_user_name: '',
        get_user_shop_name: '',
        give_user_shop_name: '',
        give_user_image: '',
        get_user_name: '',
        get_user_image: '',
        background_path: '',
        character_1_folder_path: '',
        character_1_path: '',
        character_2_path: '',
        comments: '',
        front_card_image: '',
        is_facing_type: ''
      },
      newMovieExists: false,
      recommendMovieExists: false,
      newMovieUrl: '',
      recommendMovieUrl: ''
    }
  },
  computed: {
    isEsmycardDay () {
      let today = new Date()
      if (today.getDate() == 1 || today.getDate() == 11 || today.getDate() == 21) {
        return true
      } else {
        return false
      }
    },
    isEsmycardRenewalMonth () {
      let today = new Date()
      return (today.getMonth() == 4 || today.getMonth() == 8 || today.getMonth() == 12)
    },
    isSystemManagement () {
      return window.localStorage.getItem('user_authority') === '1'
    },
    isShopMaster () {
      return window.localStorage.getItem('is_shop_master') === '1'
    },
    isClerk () {
      return window.localStorage.getItem('is_clerk') === '1'
    },
    isOfficer () {
      return window.localStorage.getItem('is_officer') === '1'
    },
    isHarassment () {
      return window.localStorage.getItem('is_harassment') === '1'
    },
    getTargetmoralCount () {
      return this.$store.getters.targetmoralCount
    },
    getNoanswermoralCount () {
      return this.$store.getters.noanswermoralCount
    },
    getMessageCount () {
      if (this.isOfficer) {
        return this.$store.getters.messageofficerCount
      } else if (this.isShopMaster) {
        return this.$store.getters.messagemanagerCount
      } else if (this.isHarassment) {
        return this.$store.getters.messageharassmentCount
      } else {
        return 0
      }
    },
    getMessageAllCount () {
      if (this.isOfficer) {
        return this.$store.getters.messageofficerAllCount
      } else if (this.isShopMaster) {
        return this.$store.getters.messagemanagerAllCount
      } else if (this.isHarassment) {
        return this.$store.getters.messageharassmentAllCount
      } else {
        return 0
      }
    },
    getUnapprovedProposeCount () {
      return this.$store.getters.unApprovedProposeCount
    },
    existRequestHolidayNotice () {
      return this.$store.getters.existRequestHolidayNotice
    },
    infoCount () {
      var count = 0
      if (this.getTargetmoralCount > 0) {
        count += 1
      }
      if (this.isShopMaster && this.getNoanswermoralCount > 0) {
        count += 1
      }
      if (this.isSystemManagement && this.getUnapprovedProposeCount > 0) {
        count += 1
      }
      if (this.getMessageCount) {
        count += 1
      }
      return count
    },
    profileImagePath () {
      return window.localStorage.getItem('profile_image_path') ? window.localStorage.getItem('profile_image_path') : ''
    },
    getUserFullName () {
      return window.localStorage.getItem('user_name')
    },
    moralWord () {
      if (this.getTargetmoralCount > 0) {
        return '月に一度、必ずモラルの確認を<br>お願いいたしますニャン♪'
      } else {
        return 'チェックありがとうだニャン！<br>また来月もよろしくだニャン♪'
      }
    },
    moralWordBox () {
      if (this.getTargetmoralCount > 0) {
        return '今月のモラルチェックをはじめる'
      } else {
        return '今月のモラルチェック回答済みです'
      }
    },
    requestHolidayWordBox () {
      if (this.existRequestHolidayNotice > 0) {
        return '翌月の希望休を提出する'
      } else if (this.in15day) {
        return '翌月の希望休を再提出する'
      } else {
        return '翌月の希望休は提出・締切済みです'
      }
    },
    messageCheck () {
      if (this.isShopMaster) {
        return '店舗長の方は、こちらからメッセージの確認をお願いします。'
      } else {
        return '相談・SOSメッセージは、こちらから確認をお願いします。'
      }
    },
    magazines () {
      return this.$store.getters.magazines
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    willMustDate () {
      var val = this.$store.getters.willMustDate
      if (val) {
        return val.replace(/(\d+)\-0?(\d+)\-(\d+)/g, '$1年$2月')
      }
    },
    in15day () {
      var hiduke = new Date()
      var day = hiduke.getDate()
      if (day <= 15) {
        return true
      } else {
        return false
      }
    },
    getFrontImageByPath () {
      return imagePath => {
        return `${imagePath}` + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      }
    },
    // 背景画像パス生成
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    // プロフィール画像パス生成
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}` + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
        }
        return require('../images/img_profile.png')
      }
    },
    // キャラクター画像パス生成
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    }
  },
  components: {
    AppHeader,
    AppFooter
  },
  filters: {
    stringTtruncate (string) {
      const maxLength = 51
      if (string.length > maxLength) {
        return `${string.substring(0, maxLength)}…`
      }
      return string
    }
  },
  methods: {
    initialization: function () {
      var data = {
        'user_id': window.localStorage.getItem('user_id')
      }
      this.$store.dispatch('EXIST_WILL_MUST_DRAFT', { data: data })
    },
    magazineGet: function () {
      var data = {
        'target_year': null,
        'only_new': true
      }
      var self = this
      var callback = function () {
        self.magazineCallbackFlag = true
      }

      this.$store.dispatch('GET_MAGAZINE', { data: data, callback: callback })
    },
    async stepupGet () {
      let data = {
        user_id: localStorage.user_id
      }
      let res = await this.$store.dispatch('GET_STEPUP_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.isStepUpExist = res.exist
      if (this.isStepUpExist) {
        this.onceEndStepUps = res.step_up_answers_once_end
        this.watchStepUps = res.step_up_answers_watch
        this.nowStepUps = res.step_up_answers_now
      } else {
        this.userTypesQuestion = res.user_types_question
      }
      this.stepUpGetEnd = true
    },
    async stepupCallGet () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('GET_STEPUP_CALL_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.isStepUpCallExist = res.call_exist
    },
    async evaluateAnswerGet () {
      const data = {
        user_id: localStorage.user_id
      }
      const res = await this.$store.dispatch('GET_EVALUATE_ANSWER_EXIST', { data: data }).catch(err => {
        console.log(err)
        return
      })
      this.isEvaluateAnswerExist = res.exist
      if (this.isEvaluateAnswerExist) {
        this.onceEndEvaluateAnswers = res.evaluate_answers_once_end
        this.watchEvaluateAnswers = res.evaluate_answers_watch
        this.nowEvaluateAnswers = res.evaluate_answers_now.data
      }
      this.evaluateAnswerGetEnd = true
    },
    async evaluateAnswerCallGet () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('GET_EVALUATE_ANSWER_CALL_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.isEvaluateAnswerCallExist = res.call_exist
    },
    async serviceAnswerGet () {
      console.log('serviceAnswerGet')
      const data = {
        user_id: localStorage.user_id
      }
      const res = await this.$store.dispatch('GET_SERVICE_ANSWER_EXIST', { data: data }).catch(err => {
        console.log(err)
        return
      })
      this.isServiceAnswerExist = res.exist
      this.serviceAnswerIsOwn = res.is_own || []
      this.serviceQuestions = res.service_questions || []
      this.serviceAnswerGetEnd = true
    },
    async serviceAnswerCallGet () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('GET_SERVICE_ANSWER_CALL_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.isServiceAnswerCallExist = res.call_exist
    },
    goMagazinePdf: function (path) {
      var url = path + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      window.open(url, '_blank')
    },
    goTop: function () {
      this.$router.push({ path: '/'})
    },
    goMoral: function () {
      if (this.getTargetmoralCount > 0) {
        this.$router.push({ path: '/moral_start'})
      } else {
        this.$router.push({ path: '/message_sent'})
      }
    },
    goMoralStart: function () {
      this.$router.push({ path: '/moral_start'})
    },
    goMoralNoAnswerList: function () {
      this.$router.push({ path: '/moral_noanswer_list'})
    },
    goFrontUrl: function (path) {
      var url = process.env.FRONT_URL + '/static/html/redirect.html'
      var redirect = path
      // url
      var query = []
      query.push('access_token=' + encodeURIComponent(window.localStorage.getItem('access_token')))
      query.push('is_shop_master=' + encodeURIComponent(window.localStorage.getItem('is_shop_master')))
      query.push('keep_limit=' + encodeURIComponent(window.localStorage.getItem('keep_limit')))
      query.push('shop_id=' + encodeURIComponent(window.localStorage.getItem('shop_id')))
      query.push('user_authority=' + encodeURIComponent(window.localStorage.getItem('user_authority')))
      query.push('user_id=' + encodeURIComponent(window.localStorage.getItem('user_id')))
      query.push('redirect=' + encodeURIComponent(redirect))
      url += '?' + query.join('&')
      window.open(url, '_blank')
    },
    goMessageList: function () {
      this.$router.push({ path: '/message_list'})
    },
    goProposeAllshopList: function () {
      this.$router.push({ path: '/propose_allshop_list'})
    },
    goMessageSendManager: function () {
      this.$router.push({ path: '/message_send_manager'})
    },
    goMessageSendOfficer: function () {
      this.$router.push({ path: '/message_send_officer'})
    },
    goMessageSendHarassment: function () {
      this.$router.push({ path: '/message_send_harassment'})
    },
    goChangePassword: function () {
      this.$router.push({ path: '/menu_reset_password'})
    },
    goProfile: function () {
      this.$router.push({ path: '/profile/' + window.localStorage.getItem('user_id') })
    },
    goRequestHolidayNew: function () {
      this.$router.push({ path: '/request_holiday/new'})
    },
    goShiftList: function () {
      var dt = new Date()
      var ym = dt.getFullYear() + '-' + ('00' + (dt.getMonth() + 1)).slice(-2)
      this.$router.push({ path: '/shift_list/' + ym})
    },
    goMagagineList: function () {
      this.$router.push({ path: '/magazine_list' })
    },
    goStepUpQuestionCheck: function(division) {
      const query = {
        division: division
      }
      this.$router.push({ path: '/stepup/question_check', query: query })
    },
    goStepUpCallList: function() {
      this.$router.push({ path: '/stepup/call_list' })
    },
    goStepUpAnswerClick: function(stepUpAnswerId) {
      this.editStepUpId = stepUpAnswerId
      var button = document.getElementById('stepUpEditModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goStepUpAnswerEdit: function() {
      this.$router.push({ path: '/stepup/' + this.editStepUpId + '/edit' })
    },
    goStepUpAnswerList: function(stepUpAnswerId) {
      this.$router.push({ path: '/stepup/' + stepUpAnswerId + '/answered_list' })
    },
    goEvaluateAnswerClick: function (evaluateAnswerId) {
      this.editEvaluateAnswerId = evaluateAnswerId
      var button = document.getElementById('evaluateAnswerEditModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goEvaluateAnswerEdit: function () {
      this.$router.push({ path: '/evaluate_answer/' + this.editEvaluateAnswerId + '/edit' })
    },
    goEvaluateAnswerList: function (evaluateAnswerId) {
      this.$router.push({ path: '/evaluate_answer/' + evaluateAnswerId + '/answered_list' })
    },
    goEvaluateAnswerCallList: function () {
      this.$router.push({ path: '/evaluate_answer/call_list' })
    },
    goEvaluateQuestionCheck: function (id) {
      this.$router.push({ path: '/evaluate_answer/' + id + '/question_check'})
    },
    goServiceAnswerList: function (serviceQuestionId) {
      const query = serviceQuestionId ? { service_question_id: serviceQuestionId } : {}
      this.$router.push({ path: '/service_answers', query: query })
    },
    goServiceAnswer: function (id) {
      this.$router.push({ path: '/service_answers/' + id })
    },
    goTreatmentSalaryList: function () {
      this.$router.push({ path: '/treatment_salary_list'})
    },
    logout: function () {
      this.$store.dispatch('LOGOUT')
    },
    onClickHelpModalShow: function () {
      var button = document.getElementById('helpModalButton')
      button.click() // モーダル表示 イベント発火
    },
    moralUnavailable: function () {
      if (this.getTargetmoralCount > 0) {
        return ''
      } else {
        return '-unavailable'
      }
    },
    moralNoAnserUnavailable: function () {
      if (this.getNoanswermoralCount > 0) {
        return ''
      } else {
        return '-unavailable'
      }
    },
    requestHolidayUnavailable: function () {
      if (this.existRequestHolidayNotice > 0) {
        return ''
      } else if (this.in15day) {
        return ''
      } else {
        return '-unavailable'
      }
    },
    messageManager: function () {
      if (this.isShopMaster) {
        return '-unavailable'
      } else {
        return ''
      }
    },
    messageOfficer: function () {
      if (this.isOfficer) {
        return '-unavailable'
      } else {
        return ''
      }
    },
    messageHarassment: function () {
      if (this.isHarassment) {
        return '-unavailable'
      } else {
        return ''
      }
    },
    messageNothing: function () {
      if (this.getMessageAllCount > 0) {
        return ''
      } else {
        return '-unavailable'
      }
    },
    noMoral: function () {
      if (this.getTargetmoralCount > 0) {
        return false
      } else {
        return true
      }
    },
    noRequestHoliday: function () {
      if (this.existRequestHolidayNotice > 0) {
        return false
      } else if (this.in15day) {
        return false
      } else {
        return true
      }
    },
    noAnserMoral: function () {
      if (this.getNoanswermoralCount > 0) {
        return false
      } else {
        return true
      }
    },
    unread: function () {
      if (this.isOfficer) {
        if (this.$store.getters.messageofficerCount > 0) {
          return true
        } else {
          return false
        }
      } else if (this.isShopMaster) {
        if (this.$store.getters.messagemanagerCount > 0) {
          return true
        } else {
          return false
        }
      } else if (this.isHarassment) {
        if (this.$store.getters.messageharassmentCount > 0) {
          return true
        } else {
          return false
        }
      }
    },
    notMessage: function () {
      if (this.getMessageAllCount > 0) {
        return false
      } else {
        return true
      }
    },
    goWillMustEdit: function () {
      this.$router.push({ path: '/will_must/edit'})
    },
    goWillMustList: function () {
      this.$router.push({ path: '/will_must_list'})
    },
    checkVideoTerms: function () {
      const button = document.getElementById('videoTermsModalButton')
      button.click()
      $('.modal-backdrop').remove()
    },
    goVideoCategories: function () {
      this.$router.push({ path: '/video_categories' })
    },
    goEsMycardSelectDesign: function () {
      this.$router.push({ path: '/select_design' })
    },
    goEsMycardList: function () {
      this.$router.push({ path: '/es_mycard_list' })
    },
    goEsMycardDetail: function (id) {
      window.sessionStorage.setItem('es_mycard_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: `/es_mycard/${id}/detail` })
    },
    async getEsMycard () {
      // ESmyカードが取得できなくてもホーム画面の他の表示は継続させる
      let res = null
      try {
        res = await this.$store.dispatch('GET_LAST_CARD')
      } catch (err) {
        console.error(err)
        return
      }
      if (res && res.attributes) {
        const card = res.attributes
        let isAlreadyRead = false
        // 自分への未読カードか判定
        if (card['is-already-read'] == 0 && card['get-user-id'] == localStorage.user_id) {
          isAlreadyRead = true
        }
        // get〜：もらった人
        // give〜：あげた人
        this.card = {
          id: res.id,
          get_user_name: `${card['get-user']['user-name']} ${card['get-user']['user-firstname']}`,
          get_user_shop_name: card['get-user']['shop-name'],
          get_user_image: card['get-user']['profile-path'],
          give_user_name: `${card['give-user']['user-name']} ${card['give-user']['user-firstname']}`,
          give_user_shop_name: card['give-user']['shop-name'],
          give_user_image: card['give-user']['profile-path'],
          front_card_image: card['front-card-image-mini'],
          is_facing_type: card['is-facing-type'],
          is_already_read: isAlreadyRead,
          background_path: card['background-path'],
          character_1_folder_path: card['character-1-folder-path'],
          character_1_path: card['character-1-path'],
          comments: card['comments']
        }
      }
    },
    checkVideoExists (url) {
      return new Promise((resolve) => {
        fetch(url, { 
          method: 'HEAD',
          headers: {
            'Authorization': window.localStorage.getItem('access_token') || ''
          }
        })
        .then(response => {
          resolve(response.ok)
        })
        .catch(() => {
          resolve(false)
        })
      })
    },
    async checkMovieExistence () {
      const apiServer = this.$store.state.config.api_method + '://' + this.$store.state.config.api_server
      
      this.newMovieUrl = apiServer + '/new_movie.mp4?t=' + Date.now()
      this.newMovieExists = await this.checkVideoExists(this.newMovieUrl)

      this.recommendMovieUrl = apiServer + '/recommend_movie.mp4?t=' + Date.now()
      this.recommendMovieExists = await this.checkVideoExists(this.recommendMovieUrl)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/home.js